'use client';

import { __assign } from '../_virtual/_tslib.js';
import React__default from 'react';
import NotificationProvider from './context/index.js';
import NotificationMain from './components/NotificationMain/index.js';

function openNotification() {
    if (typeof window === 'undefined') {
        return;
    }
    var event = new CustomEvent('VNW_OPEN_NOTIFICATION');
    window.dispatchEvent(event);
}
var Notifications = function (props) {
    return (React__default.createElement(NotificationProvider, __assign({}, props),
        React__default.createElement(NotificationMain, null)));
};
var index = React__default.memo(Notifications, function (prevProps, nextProps) {
    var _a, _b;
    // User logged in or User logged out
    if ((typeof prevProps.user === null && typeof nextProps.user !== null) ||
        (typeof prevProps.user !== null && typeof nextProps.user === null)) {
        return false;
    }
    // userId match then don't need to render
    return ((_a = prevProps.user) === null || _a === void 0 ? void 0 : _a.userId) === ((_b = nextProps.user) === null || _b === void 0 ? void 0 : _b.userId);
});

export { index as default, openNotification };
//# sourceMappingURL=index.js.map
